import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { Size } from '@Components/designConstants';
import { InteractiveDiv } from '@Components/InteractiveEl';

interface ManualMccEntryProps {
  onBack: () => void;
  onSelectMcc: (mccId: string) => void;
}

// Secondary path — the default flow is picking a company and letting CompanyMccPicker look up
// its known MCCs, but that only covers companies already onboarded into mobius_data_connectors.
export const ManualMccEntry = ({ onBack, onSelectMcc }: ManualMccEntryProps) => {
  const [mccId, setMccId] = useState('');
  const normalizedMccId = mccId.replace(/\D/g, '');

  return (
    <div className='google-ads-audit-search-panel'>
      <InteractiveDiv className='google-ads-audit-back-link' onClick={onBack}>
        ← Back
      </InteractiveDiv>
      <Form.Group>
        <Form.Label>MCC ID</Form.Label>
        <Form.Control
          placeholder='e.g. 123-456-7890'
          value={mccId}
          onChange={e => setMccId(e.target.value)}
        />
      </Form.Group>
      <Button
        size={Size.SM}
        disabled={normalizedMccId.length !== 10}
        onClick={() => onSelectMcc(normalizedMccId)}
      >
        Continue
      </Button>
    </div>
  );
};
